import { useEffect, useState } from 'react';
import { Box, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { resolveVideoPlayback } from '../../utils/videoSource';
import {
  subscribeSignedProxyCache,
  warmSignedProxyCacheFromPayload,
} from '../../utils/signedImageProxyCache';

/** Shared file or embed player. Dialogs and the media slideshow both use this. */
const VideoPlaybackBody = ({ video, title, active = true }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [signatureVersion, setSignatureVersion] = useState(0);

  useEffect(() => subscribeSignedProxyCache(() => setSignatureVersion((version) => version + 1)), []);

  useEffect(() => {
    if (active && video) {
      warmSignedProxyCacheFromPayload(video);
    }
  }, [active, video]);

  const playback = active ? resolveVideoPlayback(video) : null;
  const label = title || video?.title || '';

  if (!playback) {
    return (
      <Typography sx={{ fontFamily: 'Mulish', py: 4, textAlign: 'center' }}>
        Cette vidéo n’est pas disponible.
      </Typography>
    );
  }

  return (
    <Box>
      {playback.kind === 'file' && (
        <Box
          key={`${playback.src}-${signatureVersion}`}
          component="video"
          src={playback.src}
          controls
          playsInline
          preload="metadata"
          controlsList="nodownload"
          sx={{
            width: '100%',
            maxHeight: fullScreen ? '80vh' : '75vh',
            borderRadius: '8px',
            display: 'block',
            backgroundColor: '#000',
          }}
        >
          Votre navigateur ne prend pas en charge la lecture vidéo.
        </Box>
      )}

      {playback.kind === 'embed' && (
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%',
            borderRadius: '8px',
            overflow: 'hidden',
            backgroundColor: '#000',
          }}
        >
          <Box
            component="iframe"
            src={playback.src}
            title={label || 'Vidéo'}
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            frameBorder="0"
            sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
          />
        </Box>
      )}

      {playback.externalUrl && (
        <Box sx={{ mt: 1, textAlign: 'right' }}>
          <Link
            href={playback.externalUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontFamily: 'Mulish', fontSize: '0.85rem' }}
          >
            Ouvrir sur le site d’origine
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default VideoPlaybackBody;
